"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSchemaProperty = exports.schemas = void 0;
const service_pro_api_schema_1 = require("@msidata/service-pro-api-schema");
const lodash_1 = __importDefault(require("lodash"));
exports.schemas = {};
lodash_1.default.assign(exports.schemas, service_pro_api_schema_1.schemaData);
/**
 * Examples:
 *
 * z.getSchemaProperty("Order.OrderNumber")
 * z.getSchemaProperty("Order.OrderSegment[0].OrderLine[0].Inventory.Description")
 * z.getSchemaProperty({ entity: "Site", property: "OwningCustomer.CustomerName" })
 *
 * Returns undefined if the property is not found in the schema.
 */
function getSchemaProperty(args) {
    if (!args) {
        return undefined;
    }
    if (typeof args == "string") {
        args = {
            property: args,
            schemas: exports.schemas
        };
    }
    if (!args.property) {
        return undefined;
    }
    args.schemas = args.schemas || exports.schemas;
    var properties = args.property.split(".");
    properties = lodash_1.default.map(properties, function (p) {
        return p.indexOf("[") == -1 ? p : p.substring(0, p.indexOf("["));
    });
    if (!args.entity) {
        args.entity = properties[0];
        properties = properties.slice(1);
    }
    var schema = args.schemas[args.entity];
    if (!schema) {
        return undefined;
    }
    for (var i = 0; i < properties.length - 1; i++) {
        var navigationProperty = schema.NavigationProperties[properties[i]];
        if (!navigationProperty || !navigationProperty.Type) {
            return undefined;
        }
        schema = args.schemas[navigationProperty.Type];
        if (!schema) {
            return undefined;
        }
    }
    return (schema.Properties[properties[properties.length - 1]] ||
        schema.NavigationProperties[properties[properties.length - 1]]);
}
exports.getSchemaProperty = getSchemaProperty;
//# sourceMappingURL=schemas.js.map